export default __webpack_public_path__ + "static/media/Eyy.658b06cd.jpg";